// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yJPa3000PUGzoc23Om5a {
  display: flex;
  height: calc(100vh - 100px);
}
.yJPa3000PUGzoc23Om5a .NJNsdv6pkilMTTClAGkM {
  flex: 0 0 250px;
  min-height: 100%;
  background: #f7f8f9;
  border-radius: 2px;
  padding: 10px;
}
.yJPa3000PUGzoc23Om5a .DOkmFzeLOOO5uh0Rrgva {
  flex: auto;
  margin-left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/index.module.less"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;AAAF;AAFA;EAKI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAAJ;AATA;EAaI,UAAA;EACA,iBAAA;AADJ","sourcesContent":["\n.container {\n  display: flex;\n  height: calc(100vh - 100px);\n\n  .sider {\n    flex: 0 0 250px;\n    min-height: 100%;\n    background: #f7f8f9;\n    border-radius: 2px;\n    padding: 10px;\n  }\n\n  .content {\n    flex: auto;\n    margin-left: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `yJPa3000PUGzoc23Om5a`,
	"sider": `NJNsdv6pkilMTTClAGkM`,
	"content": `DOkmFzeLOOO5uh0Rrgva`
};
export default ___CSS_LOADER_EXPORT___;
